export default {
  // ===== 通用 =====
  "drama.common.cancel": "取消",
  "drama.common.confirm": "确认",
  "drama.common.save": "保存",
  "drama.common.edit": "编辑",
  "drama.common.delete": "删除",
  "drama.common.irreversibleHint": "此操作不可撤销",
  "drama.common.refresh": "刷新",
  "drama.common.detail": "详情",
  "drama.common.preview": "查看",
  "drama.common.empty": "—",
  "drama.common.untitled": "未命名",
  "drama.common.project": "项目",

  // ===== 工作区 tab(画布右侧 SideBar 顶部 SidebarTabBar 复用) =====
  "drama.workspace.tab.overview": "概览",
  "drama.workspace.tab.project": "项目",
  // 资产 = 角色 + 场景合并后的入口;子 Tab 仍用 characters/scenes 文案。
  "drama.workspace.tab.assets": "资产",
  "drama.workspace.tab.characters": "角色",
  "drama.workspace.tab.scenes": "场景",
  "drama.workspace.tab.episodes": "分镜",
  "drama.workspace.share": "分享",

  // ===== 画布(默认主舞台 + 全屏 layout) =====
  "drama.canvas.backToProjectList": "返回项目列表",
  "drama.overview.gotoCanvas": "打开画布",

  // ===== 项目状态 (ProjectStatusTag) =====
  "drama.projectStatus.draft": "草稿",
  "drama.projectStatus.parsing": "解析中",
  "drama.projectStatus.parsed": "已拆场",
  "drama.projectStatus.extractingChars": "抽人物中",
  "drama.projectStatus.charactersReady": "人物就绪",
  "drama.projectStatus.extractingScenes": "抽场景中",
  "drama.projectStatus.scenesReady": "场景就绪",
  "drama.projectStatus.failed": "失败",

  // ===== 项目列表页 (projects/index.tsx) =====
  "drama.projects.title": "项目制作",
  "drama.projects.newButton": "新建项目",
  "drama.projects.createCardTitle": "开始创作",
  "drama.projects.untitled": "未命名项目",
  "drama.projects.editedJustNow": "刚刚编辑",
  "drama.projects.editedMinutesAgo": "{count} 分钟前编辑",
  "drama.projects.editedHoursAgo": "{count} 小时前编辑",
  "drama.projects.editedDaysAgo": "{count} 天前编辑",
  "drama.projects.editedAt": "{time} 编辑",
  "drama.projects.loadFailed": "加载项目列表失败",
  "drama.projects.createFailed": "创建失败",
  "drama.projects.createSuccess": "已创建,进入工作区粘贴项目正文",
  "drama.projects.deleteConfirm": "删除项目?",
  "drama.projects.deleteWarning": "相关集、场、人物数据会一并删除,无法恢复。",
  "drama.projects.deleteSuccess": "已删除",
  "drama.projects.deleteFailed": "删除失败",
  "drama.projects.emptyHint": "还没有项目,点右上角『新建项目』开始",
  "drama.projects.totalCount": "共 {count} 个项目",
  "drama.projects.epLabel": "集",
  "drama.projects.sceneLabel": "场",
  "drama.projects.charLabel": "人物",
  "drama.projects.menuOpen": "打开",
  "drama.projects.menuDelete": "删除",
  "drama.projects.newModalTitle": "新建项目",
  "drama.projects.newModalOk": "创建并进入",
  "drama.projects.formTitle": "项目名",
  "drama.projects.formTitleRequired": "请输入项目名",
  "drama.projects.formTitleMaxLength": "不超过 80 字",
  "drama.projects.formTitlePlaceholder": "例如:雾港 1924",

  // ===== 工作区 - 概览页 (workspace/overview.tsx) =====
  "drama.overview.untitledProject": "未命名项目",
  "drama.overview.missingHint": "还差一步:{hint}",
  "drama.overview.checklist.parse": "拆集拆场已完成",
  "drama.overview.checklist.parseHint": "左侧粘贴正文后点 1. 拆集拆场",
  "drama.overview.checklist.charsDone": "抽取人物（{count} 位）",
  "drama.overview.checklist.charsTodo": "抽取人物",
  "drama.overview.checklist.charsHint": "完成拆集拆场后点 2. 抽取人物",
  "drama.overview.checklist.scenesDone": "抽取场景池（{count} 个）",
  "drama.overview.checklist.scenesTodo": "抽取场景池",
  "drama.overview.checklist.scenesHint": "完成抽取人物后点 3. 抽取场景池",
  "drama.overview.saveFailed": "保存失败",
  "drama.overview.saveSuccess": "已保存",
  "drama.overview.parseSuccess": "已完成拆集拆场",
  "drama.overview.parseFailed": "拆集拆场失败",
  "drama.overview.parseEmptyContent": "项目正文为空,请先粘贴",
  "drama.overview.parseRunning": "正在拆集拆场…",
  "drama.overview.extractCharsSuccess": "已抽取人物",
  "drama.overview.extractCharsFailed": "抽取人物失败",
  "drama.overview.extractScenesSuccess": "已抽取场景",
  "drama.overview.extractScenesFailed": "抽取场景失败",
  "drama.overview.extractCharsStarted":
    "已提交抽人物任务,后台跑约 1-2 分钟,可放心切页面",
  "drama.overview.extractScenesStarted":
    "已提交抽场景任务,后台跑约 1-2 分钟,可放心切页面",
  "drama.overview.charsExtractReady": "抽取人物完成 — 共 {total} 个角色",
  "drama.overview.scenesExtractReady": "抽取场景完成 — 共 {total} 个场景",
  "drama.overview.resetConfirm": "重置项目?",
  "drama.overview.resetWarning": "会清空已拆集、场、人物 — 原文保留。",
  "drama.overview.resetSuccess": "已重置,可重新解析",
  "drama.overview.resetFailed": "重置失败",
  "drama.overview.contentPlaceholder": "在此粘贴项目正文(支持 docx 拖入/上传)",
  "drama.overview.uploadDocx": "上传 .docx",
  "drama.overview.parseButton": "1. 拆集拆场",
  "drama.overview.extractCharsButton": "2. 抽取人物",
  "drama.overview.extractScenesButton": "3. 抽取场景池",
  "drama.overview.resetButton": "重置",
  "drama.overview.contentTitle": "项目正文",
  "drama.overview.flowTitle": "生产流水线",
  "drama.overview.metaCardTitle": "元数据",
  "drama.overview.metaEditButton": "编辑信息",
  "drama.overview.metaEra": "年代",
  "drama.overview.metaGenre": "类型",
  "drama.overview.metaEpisodes": "计划集数",
  "drama.overview.metaLocation": "故事地点",
  "drama.overview.metaSynopsis": "梗概",
  "drama.overview.metaSynopsisEmpty": "暂无梗概,点右上角「编辑」补一段。",
  "drama.overview.metaEpisodesTag": "{count} 集",
  "drama.overview.statEpisodes": "集",
  "drama.overview.statScenes": "场",
  "drama.overview.statCharacters": "角色",
  "drama.overview.statScenePool": "场景池",
  "drama.overview.contentCardTitle": "项目正文",
  "drama.overview.contentEdit": "编辑正文",
  "drama.overview.contentPaste": "粘贴 / 导入正文",
  "drama.overview.contentSave": "保存",
  "drama.overview.contentCancel": "取消",
  "drama.overview.contentSaveSuccess": "正文已保存",
  "drama.overview.contentEmpty":
    "尚未填写正文,点右上角『粘贴 / 导入正文』后才能拆场",
  "drama.overview.projectNotFound": "项目不存在",
  "drama.overview.parseTooShort": "请先填写 ≥ {min} 字的正文",
  "drama.overview.parseExistingTip":
    '已抽取的集不会重新跑;改了原文想全部重抽请先用"重置"',
  "drama.overview.parseIncrementalRetryTip":
    "本次将自动重跑 {failed} 集失败的(LLM 超时/异常的会重置后重新拆解);其余成功集保留不动",
  "drama.overview.parseStatus.label": "解析状态:",
  "drama.overview.parseStatus.ok": "成功 {count}",
  "drama.overview.parseStatus.partial": "不完整 {count}",
  "drama.overview.parseStatus.partialHint":
    '已有部分场景数据,「增量解析」不会自动重跑这些集(避免覆盖你可能已编辑的内容);要彻底重做请用"重置"',
  "drama.overview.parseStatus.failed": "失败 {count}",
  "drama.overview.parseStatus.failedHint":
    "点「增量解析」即可:后端会清掉失败占位并仅对这些集重跑 LLM,其余成功集不动",
  "drama.overview.parseStatus.unknown": "未知 {count}",
  "drama.overview.charsExistingTip":
    '已抽取的角色不会更新字段;想全部重抽请先用"重置"',
  "drama.overview.scenesExistingTip":
    '已抽取的场景不会更新字段;想全部重抽请先用"重置"',
  "drama.overview.enrichInProgressTip":
    "剧情正在补全细节(后台 LLM ~1-3 分钟),完成后即可抽角色 / 场景",
  "drama.overview.parseFirstButton": "1. 拆集拆场",
  "drama.overview.parseIncrementalButton": "1. 增量解析(补新增集)",
  "drama.overview.parseStartedFirst": "已开始解析,稍候自动刷新",
  "drama.overview.parseStartedIncremental":
    "已开始增量解析:旧的剧集保留,只补 LLM 新发现的",
  "drama.overview.charsFirstButton": "2. 抽取人物",
  "drama.overview.charsIncrementalButton": "2. 增量抽取人物(补新增)",
  "drama.overview.charsExtractFirst": "已抽取 {count} 个人物",
  "drama.overview.charsExtractAdded": "本次新增 {added} 个人物,共 {total} 个",
  "drama.overview.charsExtractNoChange": "已是最新,共 {total} 个",
  "drama.overview.scenesFirstButton": "3. 抽取场景池",
  "drama.overview.scenesIncrementalButton": "3. 增量抽取场景(补新增)",
  "drama.overview.scenesExtractFirst": "已抽取 {count} 个场景",
  "drama.overview.scenesExtractAdded": "本次新增 {added} 个场景,共 {total} 个",
  "drama.overview.scenesExtractNoChange": "已是最新,共 {total} 个",
  "drama.overview.flowCardTitle": "制作流程",
  "drama.overview.resetMenuLabel": "重置项目(全清重做)",
  "drama.overview.resetModalTitle": "重置该项目?",
  "drama.overview.resetModalContent":
    "集/角色/prompts/出图/sheets/场景全清,raw_text 与 meta 保留,可重新解析。",
  "drama.overview.resetOk": "重置",
  "drama.overview.metaSaveSuccess": "信息已更新",
  "drama.overview.progressOverview": "进度概览",
  "drama.overview.progressEpScene": "集 / 场:{ep} / {scene}",
  "drama.overview.progressChars": "人物:{count}",
  "drama.overview.progressScenePool": "场景池:{count}",
  "drama.overview.gotoEpisodes": "去剧场制作",
  "drama.overview.gotoCharacters": "去角色页",
  "drama.overview.gotoScenes": "去场景池",
  "drama.overview.metaModalTitle": "编辑项目信息",
  "drama.overview.metaForm.title": "项目名",
  "drama.overview.metaForm.titleRequired": "请输入项目名",
  "drama.overview.metaForm.titleMax": "不超过 80 字",
  "drama.overview.metaForm.synopsis": "梗概",
  "drama.overview.metaForm.synopsisPlaceholder":
    "一句话或一段故事概述,封面海报会基于此 prompt 生成",
  "drama.overview.metaForm.era": "年代",
  "drama.overview.metaForm.eraPlaceholder": "例如:1990 年代 / 民国 / 近未来",
  "drama.overview.metaForm.genre": "类型(回车新增标签)",
  "drama.overview.metaForm.genrePlaceholder": "例如:都市、悬疑",
  "drama.overview.metaForm.location": "故事地点",
  "drama.overview.metaForm.locationPlaceholder": "例如:上海/北京/虚构小镇",
  "drama.overview.metaForm.episodes": "计划集数",

  // ===== 工作区 - 角色列表 (workspace/characters.tsx) =====
  "drama.characters.pageTitle": "角色池",
  "drama.characters.pageSubtitle": "所有出场人物;主图与提示词都从这里下手。",
  "drama.characters.untitled": "未命名角色",
  "drama.characters.role.main": "主角",
  "drama.characters.role.support": "配角",
  "drama.characters.role.extra": "群演",
  "drama.characters.status.draft": "待生成主图",
  "drama.characters.status.canonicalReady": "主图就绪",
  "drama.characters.status.promptsReady": "提示词就绪",
  "drama.characters.status.generating": "出图中",
  "drama.characters.status.datasetReady": "素材就绪",
  "drama.characters.status.loraReady": "LoRA 已训",
  "drama.characters.extractButton": "抽取人物",
  "drama.characters.extractTooltipNeedParse": "需先在『项目概览』完成 LLM 拆场",
  "drama.characters.newButton": "新增角色",
  "drama.characters.loraWorkspaceButton": "LoRA 工作台",
  "drama.characters.emptyHint":
    "尚未抽取人物。可点右上『抽取人物』走 LLM 自动识别,或点『新增角色』手动添加。",
  "drama.characters.extractFailed": "抽取人物失败",
  "drama.characters.extractFirst": "已抽取 {count} 位人物",
  "drama.characters.extractAdded": "本次新增 {added} 位,共 {total} 位",
  "drama.characters.extractNoChange": "已是最新,共 {total} 位",
  "drama.characters.extractStarted": "已提交抽人物任务,可在『项目概览』看进度",
  "drama.characters.batchGenCanonical": "一键生成主图",
  "drama.characters.batchGenCanonicalStarted":
    "已提交 {started} 张主图任务,跳过 {skipped} 张(已完成或生成中)",
  "drama.characters.batchGenCanonicalNothing": "所有角色主图都已就绪或正在生成",
  "drama.characters.batchGenCanonicalFailed": "一键生成主图失败",
  "drama.characters.createSuccess": "已新增角色",
  "drama.characters.createFailed": "新增角色失败",
  "drama.characters.createModalTitle": "新增角色",
  "drama.characters.createOk": "创建",
  "drama.characters.formLabel.name": "角色名",
  "drama.characters.formError.nameRequired": "角色名必填",
  "drama.characters.formError.nameTooLong": "不超过 40 字",
  "drama.characters.formPlaceholder.name": "如:林秀梅",
  "drama.characters.formLabel.role": "戏份",
  "drama.characters.formLabel.gender": "性别",
  "drama.characters.formPlaceholder.gender": "female / male / 男 / 女",
  "drama.characters.formLabel.ageRange": "年龄段",
  "drama.characters.formPlaceholder.ageRange": "如:25-30",
  "drama.characters.formLabel.profile": "小传 profile",
  "drama.characters.formTooltip.profile":
    "性格 + 关键背景,≤ 50 字最佳;LLM 主图 prompt 不会直接用,但前端展示与后续微调有用",
  "drama.characters.formLabel.appearance": "外观 appearance",
  "drama.characters.formTooltip.appearance":
    "发型 / 脸型 / 体型 / 标志性特征。生成主图时这段会拼进 prompt",
  "drama.characters.formPlaceholder.appearance":
    "如:中长黑发、瓜子脸、左眉骨旧疤",
  "drama.characters.formLabel.outfit": "主服装 default_outfit",
  "drama.characters.formTooltip.outfit":
    "该角色最常穿的一套(面料/颜色/款式),会拼进主图 prompt",
  "drama.characters.formPlaceholder.outfit": "如:藏青色卡其布工装外套",
  "drama.characters.formLabel.outfitVariants": "服装变体 outfit_variants",
  "drama.characters.formTooltip.outfitVariants":
    "2-3 套戏服变体,生成 outfit Sheet 时会逐套填入",
  "drama.characters.formPlaceholder.outfitVariants": "回车追加,例如:学生制服",

  // ===== 角色详情 (workspace/character.tsx) =====
  "drama.character.shotStatus.pending": "生成中",
  "drama.character.shotStatus.processing": "生成中",
  "drama.character.shotStatus.completed": "已完成",
  "drama.character.shotStatus.failed": "失败",
  "drama.character.shotStatus.canceled": "已取消",
  "drama.character.canonicalStatus.pending": "生成中",
  "drama.character.canonicalStatus.processing": "生成中",
  "drama.character.canonicalStatus.completed": "已就绪",
  "drama.character.canonicalStatus.failed": "失败",
  "drama.character.canonicalStatus.canceled": "已取消",
  "drama.character.sheetRegenConfirm": "重新生成{name}?",
  "drama.character.sheetRegenWarning":
    "会再生成一张同 kind 大图,旧的不删,可在历史里看到。",
  "drama.character.regenButton": "重新生成",
  "drama.character.cancelButton": "取消",
  "drama.character.genCanonical": "生成主图",
  "drama.character.regenCanonical": "重生主图",
  "drama.character.canonicalReady": "主图已就绪",
  "drama.character.canonicalFailed": "主图生成失败",
  "drama.character.canonicalProcessing": "主图生成中…",
  "drama.character.genPrompts": "生成 prompt 矩阵",
  "drama.character.batchGenerate": "批量出图",
  "drama.character.exportDataset": "导出训练集 zip",
  "drama.character.tabs.canonical": "主图",
  "drama.character.tabs.prompts": "提示词矩阵",
  "drama.character.tabs.gallery": "出图相册",
  "drama.character.tabs.sheets": "Sheet 大图",
  "drama.character.tabs.lora": "LoRA",
  "drama.character.notFound": "人物不存在",
  "drama.character.headerTitle": "{name} · LoRA 工作台",
  "drama.character.profileCardTitle": "人物设定",
  "drama.character.editButton": "编辑",
  "drama.character.canonicalNotGenerated": "尚未生成",
  "drama.character.genCanonicalButton": "生成人物主图",
  "drama.character.descLabel.gender": "性别",
  "drama.character.descLabel.age": "年龄",
  "drama.character.descLabel.profile": "小传",
  "drama.character.descLabel.appearance": "外观",
  "drama.character.descLabel.outfit": "主服装",
  "drama.character.descLabel.outfitVariants": "服装变体",
  "drama.character.descLabel.sceneCount": "出场场次",
  "drama.character.metricsCardTitle": "流水线指标",
  "drama.character.metricsSelectedRate": "待出图勾选率",
  "drama.character.metricsGenProgress": "出图进度",
  "drama.character.actionsCardTitle": "操作",
  "drama.character.exportDatasetButton": "导出 LoRA 训练集({count})",
  "drama.character.refreshButton": "刷新",
  "drama.character.sheetKitTitle":
    "LoRA 训练集套装({completed} / {total} 张大图就绪)",
  "drama.character.sheetKitRegenConfirm": "重新生成全套 LoRA 训练集?",
  "drama.character.sheetKitRegenDesc": "会重新提交全部 6 张大图任务。",
  "drama.character.sheetKitRegenOk": "开始生成",
  "drama.character.sheetKitCancel": "取消",
  "drama.character.sheetKitGenAllButton": "一键生成全套(6 张)",
  "drama.character.sheetKitNeedCanonical": "需要先生成人物主图",
  "drama.character.llmPromptsTitle": "LLM 衍生 Prompts({count})",
  "drama.character.genCountLabel": "条数",
  "drama.character.regenPromptsConfirm": "重新生成衍生 Prompts?",
  "drama.character.regenPromptsDesc":
    "会清空尚未出图的现有 Prompts 草稿(已出图的会保留)。",
  "drama.character.regenPromptsOk": "重新生成",
  "drama.character.aiGenPromptsButton": "AI 生成衍生 Prompts",
  "drama.character.batchConfirm": "提交批量出图?",
  "drama.character.batchDesc": "将为 {count} 条已勾选 Prompts 出图。",
  "drama.character.batchOk": "开始出图",
  "drama.character.batchButton": "批量出图({count} 条)",
  "drama.character.noLLMPrompts": "尚未生成 LLM 提示词",
  "drama.character.bulkSelectInfo":
    "未出图 {pending} 条 · 已勾选 {selected} 条",
  "drama.character.bulkSelectAllPending": "全选未出图",
  "drama.character.bulkClearAll": "取消全选",
  "drama.character.donePromptsTag": "已出图",
  "drama.character.selectCheckbox": "勾选",
  "drama.character.bulkSelectFailed": "{ok}/{total} 已更新,{failed} 条失败",
  "drama.character.sceneTagPrefix": "场景 {key}",
  "drama.character.viewKeyMain": "主图",
  "drama.character.llmShotsTitle": "LLM 出图({count})",
  "drama.character.noLLMShots": "LLM 路径尚未出图",
  "drama.character.shotFailed": "失败",
  "drama.character.editModalTitle": "编辑人物 · {name}",
  "drama.character.formLabel.name": "角色名",
  "drama.character.formLabel.role": "戏份",
  "drama.character.formLabel.gender": "性别",
  "drama.character.formLabel.ageRange": "年龄段",
  "drama.character.formLabel.profile": "小传 profile",
  "drama.character.formLabel.appearance": "外观 appearance",
  "drama.character.formLabel.outfit": "主服装 default_outfit",
  "drama.character.formLabel.outfitVariants": "服装变体 outfit_variants",
  "drama.character.formLabel.regenCanonical": "重新生成主图",
  "drama.character.formError.nameRequired": "角色名必填",
  "drama.character.formError.nameTooLong": "不超过 40 字",
  "drama.character.formPlaceholder.gender": "female / male / 男 / 女",
  "drama.character.formPlaceholder.ageRange": "如:25-30",
  "drama.character.formPlaceholder.outfitVariants": "回车追加",
  "drama.character.formTooltip.profile": "性格 + 关键背景,≤ 50 字最佳",
  "drama.character.formTooltip.appearance":
    "发型 / 脸型 / 体型 / 标志性特征。改完需重新生成主图才会反映到出图",
  "drama.character.formTooltip.outfit":
    "该角色最常穿的一套(面料/颜色/款式)。改完需重新生成主图才会生效",
  "drama.character.formTooltip.outfitVariants":
    "2-3 套戏服变体,生成 outfit Sheet 时会按顺序填入 9 cell",
  "drama.character.formTooltip.regenCanonical":
    "只在改了外观 / 服装等会影响出图的字段后才需要点。会覆盖当前主图",
  "drama.character.regenCanonicalConfirm": "重新生成人物主图?",
  "drama.character.regenCanonicalWarning": "会覆盖当前主图。",
  "drama.character.regenCanonicalOk": "重新生成",
  "drama.character.regenCanonicalButton": "重新生成主图",
  "drama.character.editScenePopoverTitle": "编辑场景绑定",
  "drama.character.editSceneButton": "改场景",
  "drama.character.previewSceneButton": "预览场景",
  "drama.character.sceneSelectLabel": "场景",
  "drama.character.scenePlaceholder": "未绑定场景",
  "drama.character.viewSelectLabel": "视角",
  "drama.character.sheetNotReady": "四视图未就绪",
  "drama.character.viewPlaceholderNoScene": "先选场景",
  "drama.character.viewPlaceholderNotReady": "场景四视图未就绪",
  "drama.character.viewPlaceholderUnspecified": "不指定机位",
  "drama.character.cancelPopoverButton": "取消",
  "drama.character.saveButton": "保存",
  "drama.character.regenLabel": "重生",
  "drama.character.deleteSheetLabel": "删除",
  "drama.character.deleteSheetConfirm": "删除 {name}?",
  "drama.character.deleteSheetWarning":
    "删除后该 sheet 的所有 cell 都不会进入训练集导出。",
  "drama.character.genButton": "生成",
  "drama.character.cellTitleFmt": "cell {idx}",
  "drama.character.viewLargeButton": "查看大图",
  "drama.character.shotFailedFallback": "出图失败",
  "drama.character.exportFailMsg": "导出失败",
  "drama.character.exportTooLowTitle": "训练集体量偏少",
  "drama.character.exportTooLowContent":
    "当前 {total} 张，建议至少 20 张。确认导出?",
  "drama.character.canonicalGenSuccess": "已提交主图生成任务,稍等即可",
  "drama.character.canonicalGenFailed": "主图生成失败",
  "drama.character.savedProfile": "已更新人物设定",
  "drama.character.saveProfileFailed": "保存失败",
  "drama.character.genPromptsSuccess": "已生成 {count} 条提示词",
  "drama.character.genPromptsFailed": "生成失败",
  "drama.character.sheetKitSuccess": "训练集套装已提交 {count} 张大图",
  "drama.character.sheetKitFailed": "套装生成失败",
  "drama.character.sheetGenSuccess": "已提交,等待出图",
  "drama.character.sheetGenFailed": "生成失败",
  "drama.character.opFailed": "操作失败",
  "drama.character.sheetDeleteFailed": "删除失败",
  "drama.character.batchSuccess": "已提交 {submitted} 个任务{failedSuffix}",
  "drama.character.batchFailedSuffix": ",失败 {failed}",
  "drama.character.batchFailed": "批量生成失败",
  "drama.character.scenePatchSuccess": "已更新场景绑定",
  "drama.character.scenePatchFailed": "更新失败",

  // ===== 工作区 - 场景池 (workspace/scenes.tsx) =====
  "drama.scenes.poolTitle": "场景池({count})",
  "drama.scenes.untitledScene": "未命名场景",
  "drama.scenes.sheetGenerating": "四视图生成中…",
  "drama.scenes.sheetStatus.pending": "生成中",
  "drama.scenes.sheetStatus.processing": "生成中",
  "drama.scenes.sheetStatus.completed": "已生成",
  "drama.scenes.sheetStatus.failed": "失败",
  "drama.scenes.sheetStatus.canceled": "已取消",
  "drama.scenes.cellLabel.wideEstablishing": "广角空镜",
  "drama.scenes.cellLabel.mainActivity": "主活动区",
  "drama.scenes.cellLabel.dialogFront": "对话正面机位",
  "drama.scenes.cellLabel.dialogReverse": "对话反打机位",
  "drama.scenes.appearanceCount": "出场 {count}",
  "drama.scenes.extractButton": "抽取场景池",
  "drama.scenes.extractTooltipNeedParse": "需先在『项目概览』完成 LLM 拆场",
  "drama.scenes.emptyHint": "尚未抽取场景,点右上角『抽取场景池』开始",
  "drama.scenes.extractFirst": "已抽取 {count} 个场景",
  "drama.scenes.extractAdded": "本次新增 {added} 个场景,共 {total} 个",
  "drama.scenes.extractNoChange": "已是最新,共 {total} 个",
  "drama.scenes.extractFailed": "抽取场景失败",
  "drama.scenes.extractStarted": "已提交抽场景任务,可在『项目概览』看进度",
  "drama.scenes.batchGenCanonicalMaster": "一键生成场景图",
  "drama.scenes.batchGenCanonicalMasterStarted":
    "已提交 {started} 张场景图任务,跳过 {skipped} 张(已完成或生成中)",
  "drama.scenes.batchGenCanonicalMasterNothing": "所有场景图都已就绪或正在生成",
  "drama.scenes.batchGenCanonicalMasterFailed": "一键生成场景图失败",
  "drama.scenes.genSheetSuccess": "已提交场景四视图生成任务",
  "drama.scenes.genSheetFailed": "场景四视图生成失败",
  "drama.scenes.editSuccess": "已保存场景元数据",
  "drama.scenes.editFailed": "保存失败",
  "drama.scenes.regenConfirm": "重新生成场景四视图?",
  "drama.scenes.regenWarning": "会覆盖当前四视图大图。",
  "drama.scenes.regenOk": "重新生成",
  "drama.scenes.regenButton": "重新生成四视图",
  "drama.scenes.genButton": "生成场景四视图",
  "drama.scenes.editButton": "编辑",
  "drama.scenes.visualV2Button": "视觉一致性 V2",
  // ==== 场景视觉一致性 V2(档1 多 kind sheet + 档2 panorama)====
  "drama.sceneV2.drawer.title": "视觉一致性 · {name}",
  "drama.sceneV2.tab.canonical": "主锚",
  "drama.sceneV2.tab.kinds": "多视图",
  "drama.sceneV2.tab.extra": "补镜头",
  "drama.sceneV2.tab.panorama": "球面全景",

  "drama.sceneV2.canonical.tipTitle": "场景主锚 — 后续派生图的视觉真值",
  "drama.sceneV2.canonical.tipDesc":
    '生成 1 张精修主图,作为这个场景的"环境锚"。后续所有 kind 的 4 视图、补镜头、跨镜接续都会以它为 Ref#1,保证空间/材质/调色一致。Kling 3.0 / Sora 同款思路。',
  "drama.sceneV2.canonical.gen": "生成主锚",
  "drama.sceneV2.canonical.regen": "重新生成主锚",
  "drama.sceneV2.canonical.processing": "生成中...",
  "drama.sceneV2.canonical.empty": "尚未生成主锚",
  "drama.sceneV2.canonical.intro":
    "主锚定义了这个场景的房间布局、墙面材质、关键道具和光线方向。重生主锚后,已有的 sheet 与补镜头不会自动重生,需要手动重跑。",
  "drama.sceneV2.canonical.genStarted": "主锚生成已提交",
  "drama.sceneV2.canonical.genFailed": "主锚生成失败",

  "drama.sceneV2.kinds.canonicalRequiredTitle": "需要先生成主锚",
  "drama.sceneV2.kinds.canonicalRequiredDesc":
    '除了"室内主视图"以外,其他 kind 都需要主锚作 Ref#1 锁住空间一致性。请先到「主锚」tab 生成。',
  "drama.sceneV2.kinds.gen": "生成本组 4 视图",
  "drama.sceneV2.kinds.regen": "重新生成本组 4 视图",
  "drama.sceneV2.kinds.genStarted": "生成已提交",
  "drama.sceneV2.kinds.genFailed": "生成失败",
  "drama.sceneV2.kinds.errCanonicalNotReady":
    "需要先生成场景主锚才能生成此 kind。请到「主锚」tab 生成主锚后再试。",
  "drama.sceneV2.kinds.needCanonical": "请先生成场景主锚",

  "drama.sceneV2.extra.tipTitle": "补镜头 — 创作期按需追加任意角度",
  "drama.sceneV2.extra.tipDesc":
    "4 视图覆盖不到的角度,用文字描述补一张。例如「从厨房门口看餐桌」「主角床头柜俯视特写」。LLM 用主锚作 Ref#1 重绘,保证还是同一个空间。",
  "drama.sceneV2.extra.addBtn": "新增补镜头",
  "drama.sceneV2.extra.empty": "还没有补镜头。点上方按钮新增第一个。",
  "drama.sceneV2.extra.modalTitle": "新增补镜头",
  "drama.sceneV2.extra.formName": "名称(可选)",
  "drama.sceneV2.extra.formNamePlaceholder": "例如:厨房门口视角",
  "drama.sceneV2.extra.formDesc": "角度描述",
  "drama.sceneV2.extra.formDescPlaceholder":
    "例如:从厨房门口看餐桌,门框在前景,中景餐桌完整入画;光线来自客厅大窗户。",
  "drama.sceneV2.extra.formDescRequired": "请描述你想要的角度",
  "drama.sceneV2.extra.submit": "提交生成",
  "drama.sceneV2.extra.processing": "生成中...",
  "drama.sceneV2.extra.deleteConfirm": "删除这条补镜头?",
  "drama.sceneV2.extra.deleteOk": "已删除",
  "drama.sceneV2.extra.deleteFailed": "删除失败",
  "drama.sceneV2.extra.genStarted": "已提交,生成中",
  "drama.sceneV2.extra.genFailed": "生成失败",

  "drama.sceneV2.panorama.tipTitle": '球面全景 — 任意虚拟机位的"空间真值"',
  "drama.sceneV2.panorama.tipDesc":
    "上传或生成 equirectangular 2:1 全景图,前端虚拟相机可以拖任意 yaw/pitch/fov 切出透视视角。切出来的图可以直接做 storyboard 帧的接续 ref,空间锁死不会飘。",
  "drama.sceneV2.panorama.previewTitle": "当前全景图",
  "drama.sceneV2.panorama.empty": "尚未上传全景图",
  "drama.sceneV2.panorama.processing": "生成中...",
  "drama.sceneV2.panorama.upload": "上传全景图",
  "drama.sceneV2.panorama.replaceUpload": "替换全景图",
  "drama.sceneV2.panorama.uploadOk": "上传成功",
  "drama.sceneV2.panorama.uploadFailed": "上传失败",
  "drama.sceneV2.panorama.fileTooLarge": "文件超过 64MB",
  "drama.sceneV2.panorama.cameraTitle": "虚拟相机 — 切任意视角",
  "drama.sceneV2.panorama.yaw": "水平转角",
  "drama.sceneV2.panorama.pitch": "俯仰角",
  "drama.sceneV2.panorama.fov": "视场角",
  "drama.sceneV2.panorama.rerender": "重新切图",
  "drama.sceneV2.panorama.renderFailed": "切图失败",
  "drama.sceneV2.panorama.saveAsExtra": "另存为补镜头",
  "drama.sceneV2.panorama.saveModalTitle": "保存当前视角为补镜头",
  "drama.sceneV2.panorama.saveOk": "已保存",
  "drama.sceneV2.panorama.saveFailed": "保存失败",
  "drama.sceneV2.panorama.saveYpf":
    "当前虚拟机位:水平 {yaw}° / 俯仰 {pitch}° / 视场 {fov}°",
  "drama.scenes.editModalTitle": "编辑场景 · {name}",
  "drama.scenes.formLabel.name": "场景名",
  "drama.scenes.formError.nameRequired": "场景名必填",
  "drama.scenes.formLabel.description": "场景描述",
  "drama.scenes.formTooltip.description":
    "LLM 生成四视图时会用这段描述,改完记得重生四视图才会生效",
  "drama.scenes.formLabel.era": "年代",
  "drama.scenes.formPlaceholder.era": "例如:1980s",
  "drama.scenes.formLabel.timeOfDay": "时段",
  "drama.scenes.formTooltip.timeOfDay":
    "日 / 夜 / 黄昏 等;会注入四视图 prompt 的时段描述",
  "drama.scenes.formPlaceholder.timeOfDay": "例如:夜",
  "drama.scenes.formLabel.lighting": "光线 lighting",
  "drama.scenes.formTooltip.lighting":
    "四视图英文 prompt 会用这个;例如 cold fluorescent / warm incandescent",
  "drama.scenes.formPlaceholder.lighting": "例如:cold fluorescent",
  "drama.scenes.formLabel.keyProps": "标志性道具 key_props",
  "drama.scenes.formTooltip.keyProps": "回车确认每一项,会注入四视图 prompt",
  "drama.scenes.formPlaceholder.tags": "回车追加",
  "drama.scenes.formLabel.styleTags": "风格标签 style_tags",
  "drama.scenes.formTooltip.styleTags": "美术风格标签,会注入四视图 prompt",

  // ===== 场次详情 (workspace/scene-detail.tsx) =====
  "drama.sceneDetail.pageTitle": "场次详情",

  // ===== 镜目录(scene-detail 左侧 ShotsOutline) =====
  "drama.shotsOutline.title": "镜目录",
  "drama.shotsOutline.empty": "尚无分镜",
  "drama.shotsOutline.shotLabel": "镜 {shotNo}",
  "drama.shotsOutline.duration": "{sec}s",

  "drama.sceneDetail.notFoundAlert": "未找到该场次",
  "drama.sceneDetail.notFoundDesc":
    "第 {ep} 集 · {scene} 不存在或项目尚未拆解,请回到剧场制作页核对。",
  "drama.sceneDetail.stageActionPrefix": "△",
  "drama.sceneDetail.monologueTag": "OS",
  "drama.sceneDetail.narrationTag": "旁白",
  "drama.sceneDetail.cameraTag": "特写",
  "drama.sceneDetail.bulletTag": "弹幕",
  "drama.sceneDetail.infoCard": "场景信息",
  "drama.sceneDetail.label.time": "时段",
  "drama.sceneDetail.label.eventCount": "事件总数",
  "drama.sceneDetail.label.dialogue": "对白",
  "drama.sceneDetail.label.action": "动作",
  "drama.sceneDetail.label.camera": "特写",
  "drama.sceneDetail.label.monologue": "独白",
  "drama.sceneDetail.label.narration": "旁白",
  "drama.sceneDetail.label.bullet": "弹幕",
  "drama.sceneDetail.label.characters": "出场人数",
  "drama.sceneDetail.label.props": "道具件数",
  "drama.sceneDetail.label.rawTextLen": "原文字数",
  "drama.sceneDetail.label.appearingCharacters": "出场角色:",
  "drama.sceneDetail.label.propsList": "道具:",
  "drama.sceneDetail.label.emotionalTone": "情感基调:",
  "drama.sceneDetail.label.dramaticBeat": "戏剧拍点:",
  "drama.sceneDetail.label.subtext": "潜台词:",
  "drama.sceneDetail.label.plot": "梗概:",
  "drama.sceneDetail.headerEpScene": "第 {epNo} 集 · {sceneNo}",
  "drama.sceneDetail.locationEmpty": "-",
  "drama.sceneDetail.projectOriginalCard": "项目原貌(按原文顺序)",
  "drama.sceneDetail.noEvents": "本场没有事件",
  "drama.sceneDetail.rawTextCollapse": "原文片段(项目一字不差)",

  // ===== 集数 (workspace/episodes.tsx) =====
  "drama.episodes.emptyHint": "尚未拆解,先去『项目概览』完成 LLM 拆集拆场",
  "drama.episodes.summary": "共 {episodeCount} 集 / {sceneCount} 场",
  "drama.episodes.episodeNo": "第 {epNo} 集",
  "drama.episodes.outline.title": "目录",
  "drama.episodes.outline.modeEp": "集",
  "drama.episodes.outline.modeEpScene": "集 + 场",
  "drama.episodes.sceneCount": "{count} 场",
  "drama.episodes.errorDetail": "错误详情",
  "drama.episodes.noScenes": "本集无场次(可能解析失败,可看原文)",
  "drama.episodes.detailButton": "详情",
  "drama.episodes.storyboardingTag": "分镜中",
  "drama.episodes.storyboardFailedTag": "分镜失败",
  "drama.episodes.storyboardedTag": "已分镜 · {count} 镜",
  "drama.episodes.parseFailedTag": "解析失败",
  "drama.episodes.parsePartialTag": "部分缺失{pct}",
  "drama.episodes.parsePartialPct": " · {pct}",
  "drama.episodes.fallbackTitle": "项目",
  "drama.episodes.appearList": "出场:{names}",
  "drama.episodes.rawTextCollapse": "查看本集原文(解析失败回退)",

  // ===== 项目正文编辑台 (workspace/project.tsx) =====
  "drama.projectText.importDocx": "导入 docx",
  "drama.projectText.charCount": "当前 {count} 字",
  "drama.projectText.docxEmpty": "docx 解析为空,请检查文件内容",
  "drama.projectText.docxImported": "已导入 {count} 字",
  "drama.projectText.docxFailed": "docx 解析失败:{reason}",
  "drama.project.metaEpisodes": "集",
  "drama.project.metaScenes": "场",
  "drama.project.metaCharacters": "角色",
  "drama.project.statusLines": "{count} 行",
  "drama.project.statusEditing": "编辑中",
  "drama.project.statusParsing": "解析中",
  "drama.project.statusUpdated": "更新于 {time}",
  "drama.project.outline.title": "集 / 场",
  "drama.project.outline.empty": "尚未拆集拆场,先去概览解析",
  "drama.project.outline.reparseTooltip": "重跑本集(改完正文用,只跑这一集)",
  "drama.project.outline.reparseFailed": "重跑本集失败",
  "drama.project.outline.reparseQueued":
    "已提交重跑第 {epNo} 集,后台跑约 10-30 秒",
  "drama.project.outline.reparseEditingBlock":
    "正文还在编辑中,请先保存或取消编辑后再重跑",

  // ===== 拆分质量状态条 (workspace/project.tsx 顶部 Banner) =====
  // 显示已拆/计划集数比 + 漏拆/失败/部分覆盖徽标 + 一键重跑异常集按钮。
  // 仅在 parse_diagnostics 有异常或 meta.episodes > episode_count 时出现,正常拆完不打扰。
  "drama.project.quality.epsRatio": "已拆 {actual}/{planned} 集",
  "drama.project.quality.missingEps": "疑似漏拆 {count} 集",
  "drama.project.quality.failedEps": "解析失败:第 {eps} 集",
  "drama.project.quality.partialEps": "部分覆盖:第 {eps} 集",
  "drama.project.quality.reparseAbnormal": "一键重跑异常集 ({count})",
  "drama.project.quality.reparseAbnormalSuccess":
    "已提交重跑 {count} 集,后台跑约 30-90 秒",
  "drama.project.quality.reparseAbnormalFailed": "重跑异常集失败",
  "drama.project.quality.tip":
    '改完正文这条会自动消失;若是漏拆,可在正文规范"第 X 集"分隔符后再次解析',

  // ===== 自动保存 + 版本历史 (workspace/project.tsx + ProjectHistoryDrawer.tsx) =====
  "drama.project.autosave.idle": "自动保存",
  "drama.project.autosave.dirty": "编辑中…",
  "drama.project.autosave.saving": "保存中…",
  "drama.project.autosave.saved": "已保存 · {ago}",
  "drama.project.autosave.justNow": "刚刚",
  "drama.project.autosave.secondsAgo": "{sec} 秒前",
  "drama.project.autosave.minutesAgo": "{min} 分钟前",
  "drama.project.autosave.failed": "保存失败,点此重试",
  "drama.project.autosave.disabledParsing": "解析中,暂停自动保存",
  "drama.project.autosave.disabledNoAccess": "只读",
  "drama.project.history.openButton": "历史",
  "drama.project.history.markButton": "保存存档点",
  // 画布双击 ProjectNode/EpisodeNode 弹起的项目编辑 SideBar(根布局右侧
  // Splitter Panel,ProjectEditorPanel.tsx)
  "drama.project.editor.drawerTitle": "项目编辑",
  "drama.project.editor.emptyContent":
    "项目还没有正文,在「项目」tab 上传 docx 或粘贴正文后再回来编辑。",
  "drama.canvas.projectEditor.close": "收起项目编辑",
  // 画布右侧 SideBar(顶部 SidebarTabBar 切 4 个 Panel)。
  // SidebarTabBar 自身的 4 个 tab label 复用 drama.workspace.tab.*(原顶 Segmented 同款 i18n)。
  "drama.canvas.sidebar.close": "收起侧栏",
  "drama.canvas.sidebar.expand": "展开侧栏",
  "drama.project.history.markPlaceholder": "给当前版本起个名字(可选)",
  "drama.project.history.markOk": "已存为版本 v{version}",
  "drama.project.history.markFailed": "保存版本失败",
  "drama.project.history.drawerTitle": "版本历史",
  "drama.project.history.drawerEmpty": "还没有版本快照",
  "drama.project.history.colVersion": "版本",
  "drama.project.history.colWho": "作者",
  "drama.project.history.colTrigger": "来源",
  "drama.project.history.colChars": "字数",
  "drama.project.history.colTime": "时间",
  "drama.project.history.colActions": "操作",
  "drama.project.history.actionCompare": "对比",
  "drama.project.history.actionRevert": "回滚到此",
  "drama.project.history.trigger.auto_idle": "自动",
  "drama.project.history.trigger.auto_threshold": "阶段保存",
  "drama.project.history.trigger.exit": "离开页面",
  "drama.project.history.trigger.manual": "手动标记",
  "drama.project.history.trigger.revert": "回滚备份",
  "drama.project.history.delta.add": "+{count}",
  "drama.project.history.delta.del": "−{count}",
  "drama.project.history.compareTitle": "对比 v{version} 与当前版本",
  "drama.project.history.compareLoading": "加载中…",
  "drama.project.history.compareLoadFailed": "加载历史版本失败",
  "drama.project.history.revertConfirmTitle": "回滚到 v{version}?",
  "drama.project.history.revertConfirmContent":
    '会用 v{version} 的正文覆盖当前内容,但已生成的角色 / 场景 / 分镜不会被删除,只会标记"来自旧版本",由你决定是否重抽。回滚前会自动备份当前内容为新版本,可以再次回滚。',
  "drama.project.history.revertConfirmOk": "回滚",
  "drama.project.history.revertConfirmCancel": "不回了",
  "drama.project.history.revertOk": "已回滚到 v{version}",
  "drama.project.history.revertFailed": "回滚失败",
  "drama.project.history.staleHint": "项目被回滚过,该项可能与当前正文不一致",
  "drama.project.history.diffHintTooltip":
    "黄色竖条标记自上次自动保存以来变化过的行;保存后会清掉",

  // ===== 资产台抽屉 (components/ShotQueueDock.tsx) =====
  "drama.shotQueueDock.title": "资产台",

  // ===== 转存对话框 (components/ImportDialog.tsx) =====
  "drama.importDialog.titleBatch": "转存当前目录到我的图库",
  "drama.importDialog.titleBatchCount": "转存当前目录({count} 项)到我的图库",
  "drama.importDialog.titleSingle": "转存到我的图库",
  "drama.importDialog.titleSingleName": "转存到我的图库({name})",
  "drama.importDialog.okText": "开始转存",
  "drama.importDialog.folderLabel": "目录",
  "drama.importDialog.folderTooltip": "留空进默认目录;可选已有目录或新建一个",
  "drama.importDialog.folderPlaceholder": "选择已有目录或新建",
  "drama.importDialog.notesLabel": "备注",
  "drama.importDialog.notesPlaceholder": "可选:这批素材的用途、镜头说明等",
  "drama.importDialog.tagsLabel": "标签",
  "drama.importDialog.tagsPlaceholder": "回车添加多个标签",

  // ===== Prompt 模板 (prompt-templates/index.tsx) =====
  "drama.prompts.pageTitle": "提示词模板",
  "drama.prompts.refreshButton": "刷新",
  "drama.prompts.noCategories": "暂无可配置的 Prompt 类目",
  "drama.prompts.loadCategoriesFailed": "加载类目失败",
  "drama.prompts.loadFailed": "加载失败",
  "drama.prompts.emptyContentHint": "内容不能为空,如需清空请用「恢复默认」",
  "drama.prompts.saveFailed": "保存失败",
  "drama.prompts.saveSuccess": "已保存为我的版本",
  "drama.prompts.resetFailed": "重置失败",
  "drama.prompts.resetSuccess": "已恢复默认",
  "drama.prompts.fillDefaultInfo": "已用默认内容填充编辑器(尚未保存)",
  "drama.prompts.fillDefaultButton": "用默认值填充",
  "drama.prompts.modalCancel": "取消",
  "drama.prompts.saveButton": "保存为我的版本",
  "drama.prompts.columnName": "名称",
  "drama.prompts.columnDeprojection": "说明",
  "drama.prompts.columnLength": "内容长度",
  "drama.prompts.columnUpdateTime": "更新时间",
  "drama.prompts.columnActions": "操作",
  "drama.prompts.charCount": "{count} 字符",
  "drama.prompts.defaultTag": "默认",
  "drama.prompts.modifiedTag": "已自定义",
  "drama.prompts.unmodifiedTag": "未修改",
  "drama.prompts.editButtonModified": "编辑",
  "drama.prompts.editButton": "修改",
  "drama.prompts.resetConfirm": "恢复默认?",
  "drama.prompts.resetConfirmDesc":
    "将删除你对该 prompt 的自定义,回到内置默认值。",
  "drama.prompts.resetOk": "恢复",
  "drama.prompts.resetButton": "恢复默认",
  "drama.prompts.categoryDefaultBadge": "该类目默认",
  "drama.prompts.unmodifiedHint": "当前显示的是默认值",
  "drama.prompts.variablesTitle": "可用占位符(后端调用时自动替换,请保留)",
  "drama.prompts.textareaPlaceholder":
    "LLM system prompt — 影响该类目下所有调用",
  "drama.prompts.charStatsLength": "当前 {count} 字符",
  "drama.prompts.charStatsDefault": "· 默认 {count} 字符",
  "drama.prompts.charStatsSameAsDefault": "(与默认一致)",
  "drama.prompts.modalEditTitle": "编辑 — {name}",
  "drama.prompts.unmodifiedHintFull": "未修改 → 当前显示的是默认值",
  "drama.prompts.dashPlaceholder": "—",
  "drama.prompts.category.storyboard": "分镜导演",
  "drama.prompts.category.extract_characters": "抽取角色",
  "drama.prompts.category.extract_scenes": "抽取场景",
  "drama.prompts.category.character_prompts": "衍生角色 prompt",
  "drama.prompts.category.detect_episode_marker": "识别集分隔符",
  "drama.prompts.category.character_sheet": "角色 Sheet 出图",
  "drama.prompts.category.scene_sheet": "场景 Sheet 出图",
  "drama.prompts.category.shot_frame": "分镜帧出图",

  // ===== 工作区组件 =====
  // ImportDialog / ImportToWorkflowDialog
  "drama.import.dialogTitle": "导入到工作流",
  "drama.import.confirmButton": "确认导入",
  "drama.import.cancelButton": "取消",
  "drama.import.successTip": "已导入",
  "drama.import.failedTip": "导入失败",
  "drama.import.workflowLabel": "选择工作流模板",
  "drama.import.workflowPlaceholder": "请选择工作流",
  "drama.import.targetSlotLabel": "目标 slot",
  "drama.import.firstFrame": "首帧",
  "drama.import.middleFrame": "中帧",
  "drama.import.lastFrame": "尾帧",
  "drama.import.refImageLabel": "参考图",

  // ShotQueueDock
  "drama.shotQueue.assetPanelAlt": "资产台",
  "drama.shotQueue.assetPanelTitle": "资产台",
  "drama.shotQueue.queueTab": "派发队列",
  "drama.shotQueue.galleryTab": "产出相册",
  "drama.shotQueue.empty": "暂无任务",
  "drama.shotQueue.cancelAll": "清空",

  // OutputsGalleryTab
  "drama.gallery.source.all": "全部来源",
  "drama.gallery.source.characterShot": "角色单图",
  "drama.gallery.source.characterSheet": "角色 Sheet",
  "drama.gallery.source.storyboardFrame": "分镜帧",
  "drama.gallery.source.canvasImage": "画布生图",
  "drama.gallery.source.canvasVideo": "画布生视频",
  "drama.gallery.source.canvasAudio": "画布配音",
  "drama.gallery.source.storyboardAudio": "镜头配音",
  "drama.gallery.sourceLabel.characterShot": "单图",
  "drama.gallery.sourceLabel.characterSheet": "Sheet",
  "drama.gallery.sourceLabel.storyboardFrame": "分镜帧",
  "drama.gallery.sourceLabel.canvasImage": "画布图",
  "drama.gallery.sourceLabel.canvasVideo": "画布视频",
  "drama.gallery.sourceLabel.canvasAudio": "画布配音",
  "drama.gallery.sourceLabel.storyboardAudio": "镜头配音",
  "drama.gallery.scope.project": "本项目",
  "drama.gallery.scope.all": "全部",
  "drama.gallery.cachedTag": "cached",
  "drama.gallery.emptyHint": "暂无产出",
  "drama.gallery.loadFailed": "加载产出失败",
  "drama.gallery.subtitle.storyboardFrame":
    "EP{epNo} S{sceneNo} 镜{shotNo} {slot}",
  "drama.gallery.subtitle.sheet": "Sheet",
  "drama.gallery.subtitle.characterShot": "单图",

  // StoryboardPanel - cells / slots
  "drama.storyboard.cellLabel.wide": "广角",
  "drama.storyboard.cellLabel.master": "主镜",
  "drama.storyboard.cellLabel.front": "正面",
  "drama.storyboard.cellLabel.reverse": "反打",
  "drama.storyboard.cellLabel.closeup": "特写",
  "drama.storyboard.slotLabel.first": "首帧",
  "drama.storyboard.slotLabel.middle": "中帧",
  "drama.storyboard.slotLabel.last": "尾帧",
  // 镜头语言四维(shot_size / angle / movement / shot_role)中文映射
  "drama.storyboard.shotSize.ecu": "极特写",
  "drama.storyboard.shotSize.cu": "特写",
  "drama.storyboard.shotSize.mcu": "中近景",
  "drama.storyboard.shotSize.ms": "中景",
  "drama.storyboard.shotSize.mls": "中远景",
  "drama.storyboard.shotSize.ls": "全景",
  "drama.storyboard.shotSize.els": "大全景",
  "drama.storyboard.shotSize.overTheShoulder": "过肩",
  "drama.storyboard.shotSize.twoShot": "双人",
  "drama.storyboard.shotSize.insert": "插入特写",
  "drama.storyboard.angle.eyeLevel": "平视",
  "drama.storyboard.angle.high": "俯视",
  "drama.storyboard.angle.low": "仰视",
  "drama.storyboard.angle.dutch": "倾斜",
  "drama.storyboard.angle.overhead": "顶视",
  "drama.storyboard.angle.pov": "主观",
  "drama.storyboard.movement.static": "固定",
  "drama.storyboard.movement.pan": "横摇",
  "drama.storyboard.movement.tilt": "纵摇",
  "drama.storyboard.movement.dollyIn": "推镜",
  "drama.storyboard.movement.dollyOut": "拉镜",
  "drama.storyboard.movement.handheld": "手持",
  "drama.storyboard.movement.crane": "升降",
  "drama.storyboard.movement.track": "跟移",
  "drama.storyboard.shotRole.dialog": "对白",
  "drama.storyboard.shotRole.master": "盖镜",
  "drama.storyboard.shotRole.reaction": "反应",
  "drama.storyboard.shotRole.insert": "插入",
  "drama.storyboard.shotRole.cutaway": "旁观",
  "drama.storyboard.shotRole.pov": "主观",
  "drama.storyboard.shotRole.reveal": "揭示",
  "drama.storyboard.shotRole.beat": "呼吸",
  "drama.storyboard.cinemaDim.shotSize": "景别",
  "drama.storyboard.cinemaDim.angle": "机位",
  "drama.storyboard.cinemaDim.movement": "运镜",
  "drama.storyboard.cinemaDim.shotRole": "叙事职能",
  "drama.storyboard.shotLabel": "镜 {shotNo}",
  "drama.storyboard.dispatchButton": "派发出图",
  "drama.storyboard.dispatchSuccess": "已派发",
  "drama.storyboard.dispatchFailed": "派发失败",
  "drama.storyboard.regenButton": "重新生成",
  "drama.storyboard.importButton": "导入到工作流",
  "drama.storyboard.uploadButton": "上传替换",
  "drama.storyboard.deleteButton": "删除",
  "drama.storyboard.frameMissing": "帧缺失",

  // ===== 分镜表 (components/StoryboardPanel.tsx) =====
  // FrameSlotCell
  "drama.storyboard.frameStatus.generating": "生成中",
  "drama.storyboard.frameStatus.failed": "失败",
  "drama.storyboard.frameStatus.notGenerated": "未生成",
  "drama.storyboard.frameStatus.failedDefault": "生成失败",
  "drama.storyboard.frameStatus.deleteFrame": "删除此帧",

  // ShotFrameDrawer
  "drama.storyboard.refDrawer.titleWithShot": "配置参考图 · 镜 {shotNo}",
  "drama.storyboard.refDrawer.title": "配置参考图",
  "drama.storyboard.refDrawer.submit": "生成",
  "drama.storyboard.refDrawer.sceneRefTitle": "场景参考(Ref#2)",
  "drama.storyboard.refDrawer.sceneRefOverridden":
    "已选接续参考图 → 首帧场景 cell 不生效(中/尾帧仍用)",
  "drama.storyboard.refDrawer.sceneRefEmptyMsg": "本剧暂无已生成场景大图",
  "drama.storyboard.refDrawer.sceneRefEmptyDesc":
    "请先到场景页生成场景四视图。",
  "drama.storyboard.refDrawer.sceneRefNone": "不使用场景参考(纯文生图)",
  "drama.storyboard.refDrawer.viewKeyTitle": "视角(view_key)",
  "drama.storyboard.refDrawer.viewKeyHint":
    "点缩略图选定;留空 = 让模型读整张大图",
  "drama.storyboard.refDrawer.charRefTitle": "额外参考图(Ref#1,角色主图)",
  "drama.storyboard.refDrawer.charRefEmpty":
    "本剧暂无已生成主图的角色。可去角色页生成。",
  "drama.storyboard.refDrawer.charRefSelected":
    "已选 {count} 个角色(最多 {max} 个;Ref# 顺序按选择先后)",
  "drama.storyboard.refDrawer.framePromptTitle": "文案 / 镜头补充",
  "drama.storyboard.refDrawer.framePromptPlaceholder":
    "可选。例如:特写姜禾抬眸瞬间,光从窗外斜切。留空走 LLM 已写好的镜头描述。",
  "drama.storyboard.refDrawer.framesTitle": "生成哪些帧",
  "drama.storyboard.refDrawer.frameFirst": "首帧(必选,作为视频生成首帧)",
  "drama.storyboard.refDrawer.frameMiddle": "中帧",
  "drama.storyboard.refDrawer.frameLast": "尾帧",
  "drama.storyboard.refDrawer.force": "强制重生(覆盖已完成帧)",

  // ContinuityImage(接续参考图卡 + Picker)
  "drama.continuity.title": "接续参考图(Ref#1)",
  "drama.continuity.subtitle": "可选。仅作用于首帧,顶替场景 cell。",
  "drama.continuity.pickEmpty": "选择接续参考图",
  "drama.continuity.pickHint": "可从当前场景的某帧或资产台中选取",
  "drama.continuity.change": "更换",
  "drama.continuity.changeTooltip": "点击更换图片",
  "drama.continuity.clear": "清除",
  "drama.continuity.cardCaption.shotFrame": "镜 {shotNo} · {slot}",
  "drama.continuity.cardCaption.externalImport": "资产台素材",
  "drama.continuity.cardCaption.sceneCanonical": "场景主锚",
  "drama.continuity.cardCaption.sceneExtra": "场景补镜头",
  "drama.continuity.cardCaption.panoramaView":
    "全景 · 水平 {yaw}° / 俯仰 {pitch}°",
  "drama.continuity.picker.title": "选择接续参考图",
  "drama.continuity.picker.tab.project": "项目产出",
  "drama.continuity.picker.tab.asset": "资产台",
  "drama.continuity.picker.scope.current": "当前场景",
  "drama.continuity.picker.scope.all": "全部我的产出",
  "drama.continuity.picker.scene.empty":
    "本场暂无可用帧。请先生成至少一镜的首/中/尾帧。",
  "drama.continuity.picker.all.empty":
    "暂无可用项目帧。请先到任意分镜生成首/中/尾帧。",
  "drama.continuity.picker.all.epLabel": "集 {epNo}",
  "drama.continuity.picker.scene.caption": "镜 {shotNo} · {slot}",
  "drama.continuity.picker.scene.slotFirst": "首帧",
  "drama.continuity.picker.scene.slotMiddle": "中帧",
  "drama.continuity.picker.scene.slotLast": "末帧",
  "drama.continuity.picker.asset.empty":
    "资产台暂无图片素材。可在我的图库转存。",
  // ==== 接续图选择器:场景视图 / 全景视角 tab(档1+档2)====
  "drama.continuity.picker.tab.scene": "场景视图",
  "drama.continuity.picker.tab.panorama": "全景视角",
  "drama.continuity.picker.scene.emptyV2":
    "本项目暂无场景主锚或补镜头。请先到「资产 · 场景」页生成场景主锚和补镜头。",
  "drama.continuity.picker.scene.canonicalCaption": "{name} · 主锚",
  "drama.continuity.picker.scene.canonicalSubtitle": "场景空间真值",
  "drama.continuity.picker.scene.extraDefaultCaption": "补镜头",
  "drama.continuity.picker.panorama.empty":
    "本项目暂无可用全景图。请先到任一场景的「视觉一致性 V2」抽屉上传或生成全景。",
  "drama.continuity.picker.panorama.sceneLabel": "场景:",
  "drama.continuity.picker.panorama.scenePlaceholder": "选场景",
  "drama.continuity.picker.panorama.selectFirst": "请先选场景",
  "drama.continuity.picker.panorama.yaw": "水平",
  "drama.continuity.picker.panorama.pitch": "俯仰",
  "drama.continuity.picker.panorama.fov": "视场",
  "drama.continuity.picker.panorama.rerender": "重新切图",
  "drama.continuity.picker.panorama.pick": "使用此视角",
  "drama.continuity.picker.panorama.repick": "已选 · 重选",
  "drama.continuity.picker.panorama.curParams":
    "当前:水平 {yaw}° / 俯仰 {pitch}° / 视场 {fov}°",

  // VideoPromptBlock
  "drama.storyboard.video.defaultTpl": "默认模板",
  "drama.storyboard.video.title": "视频提示词",
  "drama.storyboard.video.countSummary": "共 {count} 套",
  "drama.storyboard.video.partialInFlight": " · 部分生成中",
  "drama.storyboard.video.notGenerated": "未生成",
  "drama.storyboard.video.needFirstFrame": "需先生成首帧",
  "drama.storyboard.video.tooltipMore": "勾选模板,补生成更多套或重生",
  "drama.storyboard.video.tooltipFirst": "勾选模板,生成视频提示词",
  "drama.storyboard.video.tooltipNeedFirstFrame": "请先生成首帧",
  "drama.storyboard.video.regenMore": "生成更多套 / 重生",
  "drama.storyboard.video.generate": "生成提示词",
  "drama.storyboard.video.tagPrimary": "主选",
  "drama.storyboard.video.tagCharCount": "· {count} 字",
  "drama.storyboard.video.statusReady": "就绪 · {sec}s",
  "drama.storyboard.video.statusFailed": "失败",
  "drama.storyboard.video.statusInFlight": "生成中",
  "drama.storyboard.video.statusQueued": "排队中",
  "drama.storyboard.video.actionCopy": "复制",
  "drama.storyboard.video.actionSetPrimary": "设为主选",
  "drama.storyboard.video.actionRetry": "重试",
  "drama.storyboard.video.actionDeleteEntry": "删除此条目",
  "drama.storyboard.video.alertFailed": "LLM 生成失败",
  "drama.storyboard.video.modalTitle": "生成视频提示词",
  "drama.storyboard.video.modalOkForce": "强制重生选中",
  "drama.storyboard.video.modalOkStart": "开始生成",
  "drama.storyboard.video.modalDesc":
    "一次可勾选多个模板,后端并发跑(同 shot 软上限 3),每个模板对应一条 prompt 条目。 首条完成自动占主,可在条目卡片上手动切主或删除。",
  "drama.storyboard.video.modalSelectTpl": "选择模板",
  "drama.storyboard.video.modalNoTpl": "暂无模板,将走系统默认。",
  "drama.storyboard.video.tplBuiltinSuffix": "{name} · 内置",
  "drama.storyboard.video.tplExists": "已存在",
  "drama.storyboard.video.tplCatAction": "动作专用",
  "drama.storyboard.video.tplCatZhPlain": "中文白描",
  "drama.storyboard.video.tplCatEnStructured": "英文结构化",
  "drama.storyboard.video.tplSearchPh": "搜索模板（名称 / 描述 / 标签）",
  "drama.storyboard.video.tplSearchEmpty": "没有匹配的模板",
  "drama.storyboard.video.modalDefaultHint":
    "不勾任何模板 = 系统默认(LTX-2.3 i2v)。本次确认后会记忆,下次自动勾上。",
  "drama.storyboard.video.modalForce": "强制重生(覆盖已存在的同模板条目)",
  "drama.storyboard.video.modalForceHint":
    "勾选的模板都已有条目,启用强制重生才能覆盖。",
  // toasts in VideoPromptBlock
  "drama.storyboard.video.copySuccess": "已复制到剪贴板",
  "drama.storyboard.video.copyFailed": "复制失败,请手动选取",
  "drama.storyboard.video.setPrimarySuccess": "已切换主选",
  "drama.storyboard.video.setPrimaryFailed": "设置主选失败",
  "drama.storyboard.video.deleteInFlight": "生成中,无法删除",
  "drama.storyboard.video.deleteConfirmTitle": "删除「{name}」的提示词?",
  "drama.storyboard.video.deleteConfirmPrimary":
    "此条目当前是主选,删除后系统会自动切到其他完成态条目(若有)。",
  "drama.storyboard.video.deleteConfirmDefault": "此操作不可撤销。",
  "drama.storyboard.video.deleteOk": "删除",
  "drama.storyboard.video.deleteSuccess": "已删除「{name}」",
  "drama.storyboard.video.deleteFailed": "删除失败",
  "drama.storyboard.video.retrySuccess": "已重新下发",
  "drama.storyboard.video.submitFailed": "提交失败",
  "drama.storyboard.video.dispatchSuccess":
    "已下发 {count} 套提示词,LLM 生成中…",
  "drama.storyboard.video.alreadyLatest": "已有最新 prompt,无需重生",

  // ShotCard
  "drama.storyboard.shotCard.shotLabel": "镜 {shotNo}",
  "drama.storyboard.shotCard.expandDetails": "详情",
  "drama.storyboard.shotCard.collapseDetails": "收起",
  "drama.storyboard.shotGrid.noContent": "(无内容)",
  "drama.storyboard.shotCard.subjects": "出镜：{names}",
  "drama.storyboard.shotCard.composition": "构图：{value}",
  "drama.storyboard.shotCard.framePanelTitle": "帧出图",
  "drama.storyboard.shotCard.scenePrefix": "场景：",
  "drama.storyboard.shotCard.charactersPrefix": "人物参考：",
  "drama.storyboard.shotCard.downloadFrames": "下载帧",
  "drama.storyboard.shotCard.configGenerate": "配置/生成",
  "drama.storyboard.shotCard.dispatchedSlots": "已下发 {labels}",
  "drama.storyboard.shotCard.configSaved": "配置已保存",
  "drama.storyboard.shotCard.submitFailed": "提交失败",
  "drama.storyboard.shotCard.noDownloadable": "暂无可下载帧",
  "drama.storyboard.shotCard.downloadAllSuccess": "已下载 {count} 张帧",
  "drama.storyboard.shotCard.downloadAllFailed": "下载失败 {count} 张",
  "drama.storyboard.shotCard.downloadPartial":
    "已下载 {success} 张,失败 {failed} 张",
  "drama.storyboard.shotCard.deleteFrameTitle": "删除{slotLabel}?",
  "drama.storyboard.shotCard.deleteFrameContent":
    '此操作不可撤销。如需重新出图,可在"配置/生成"中再次生成。',
  "drama.storyboard.shotCard.deleteFrameOk": "删除",
  "drama.storyboard.shotCard.deleteFrameCancel": "取消",
  "drama.storyboard.shotCard.deleteFrameSuccess": "已删除{slotLabel}",
  "drama.storyboard.shotCard.deleteFrameFailed": "删除失败",

  // Main panel
  "drama.storyboard.panel.cardTitle": "分镜表",
  "drama.storyboard.panel.empty": "尚未生成本场分镜",
  "drama.storyboard.panel.generateButton": "生成分镜",
  "drama.storyboard.panel.statusInFlight": "生成中",
  "drama.storyboard.panel.statusFailed": "生成失败",
  "drama.storyboard.panel.statusPartial": "部分缺失",
  "drama.storyboard.panel.statusReady": "就绪",
  "drama.storyboard.panel.shotsCount": "{count} 镜",
  "drama.storyboard.panel.durationApprox": "约 {value}",
  "drama.storyboard.panel.durationApproxTarget": "约 {value} / 目标 {target}s",
  "drama.storyboard.panel.coverage": "覆盖率 {pct}%",
  "drama.storyboard.panel.importButton": "导入到工作流",
  "drama.storyboard.panel.menuRegen": "重生",
  "drama.storyboard.panel.menuDelete": "删除",
  "drama.storyboard.panel.deleteConfirmTitle": "删除本场分镜?",
  "drama.storyboard.panel.deleteConfirmContent": "后续可重新生成。",
  "drama.storyboard.panel.deleteOk": "删除",
  "drama.storyboard.panel.deleteCancel": "取消",
  "drama.storyboard.panel.deleteSuccess": "已删除",
  "drama.storyboard.panel.deleteFailed": "删除失败",
  "drama.storyboard.panel.inFlightTitle": "LLM 正在生成中,通常 10~30 秒",
  "drama.storyboard.panel.inFlightDesc":
    "异步任务,关闭页面也会继续跑完;回来再看就行。",
  "drama.storyboard.panel.intent": "意图:{value}",
  "drama.storyboard.panel.failedTitle": "LLM 生成失败",
  "drama.storyboard.panel.failedFallback": '可点"重生"重试',
  "drama.storyboard.panel.partialTitle": "覆盖率 {pct}% 偏低",
  "drama.storyboard.panel.partialDesc":
    "LLM 漏掉了部分原文事件,可调整目标时长后点重生。",
  "drama.storyboard.panel.noShots": "无镜头",
  "drama.storyboard.panel.viewList": "列表",
  "drama.storyboard.panel.viewGrid": "网格",
  "drama.storyboard.panel.viewTimeline": "时间轴",
  "drama.storyboard.panel.expandAll": "全部展开",
  "drama.storyboard.panel.collapseAll": "全部收起",
  "drama.storyboard.panel.searchPlaceholder": "搜索镜号 / beat / 对白 / 动作",
  "drama.storyboard.panel.filterAll": "全部",
  "drama.storyboard.panel.filterNoFrame": "只看缺图",
  "drama.storyboard.panel.filterCompleted": "只看完成",
  "drama.storyboard.panel.matchCount": "匹配 {matched}/{total}",
  "drama.storyboard.panel.filterEmpty": "没有镜匹配当前筛选",
  "drama.storyboard.panel.modalTitleRegen": "重新生成分镜",
  "drama.storyboard.panel.modalTitleNew": "生成分镜",
  "drama.storyboard.panel.modalOkRegen": "重新生成",
  "drama.storyboard.panel.modalOkStart": "开始生成",
  "drama.storyboard.panel.modalCancel": "取消",
  "drama.storyboard.panel.modalDesc":
    "LLM 自动判断镜数、时长、镜头语言,通常 10~30 秒返回。 异步生成,关闭页面也会继续跑完。",
  "drama.storyboard.panel.modalDescRegenSuffix": "重新生成会覆盖当前分镜表。",
  "drama.storyboard.panel.targetSec": "目标时长",
  "drama.storyboard.panel.targetSecPlaceholder": "自动",
  "drama.storyboard.panel.targetSecAddon": "秒",
  "drama.storyboard.panel.targetSecHint":
    "留空 / 0 = 完全自适应,LLM 看戏决定;>0 = 收敛到该时长 ±15%。",
  "drama.storyboard.panel.toastFailed": "分镜生成失败",
  "drama.storyboard.panel.toastPartialCoverage":
    "分镜已生成,但覆盖率 {pct}% 偏低",
  "drama.storyboard.panel.toastReady": "已生成 {count} 个镜头",
  "drama.storyboard.panel.submitFailed": "提交失败",

  // ===== 产出图库 (components/OutputsGalleryTab.tsx) =====
  "drama.outputsGallery.tab.project": "项目产出",
  "drama.outputsGallery.tab.mine": "我的图库",
  "drama.outputsGallery.subtitle.sheetFallback": "sheet",
  "drama.outputsGallery.totalCount": "共 {count}",
  "drama.outputsGallery.deleteTooltip": "删除此图",
  "drama.outputsGallery.deleteConfirmTitle": "确认删除?",
  "drama.outputsGallery.deleteConfirmDesc":
    "MinIO 文件保留(留作排错痕迹),仅删除此条记录;in-flight 帧无法删除。",
  "drama.outputsGallery.deleteOk": "删除",
  "drama.outputsGallery.deleteSuccess": "已删除",
  "drama.outputsGallery.deleteFailed": "删除失败",

  // ===== 我的图库 (components/MyGalleryPanel.tsx) =====
  "drama.myGallery.storage.label": "存储用量",
  "drama.myGallery.storage.fileCount":
    "{count, plural, =0 {暂无文件} other {# 个文件}}",
  // 用量条 Tooltip 内的分类标签(与后端 user_storage breakdown.kind 一一对应)
  "drama.myGallery.storage.kind.import": "我的图库",
  "drama.myGallery.storage.kind.canvas_image": "画布生图",
  "drama.myGallery.storage.kind.canvas_video": "画布生视频",
  "drama.myGallery.storage.kind.canvas_audio": "画布配音",
  "drama.myGallery.storage.kind.storyboard_audio": "镜头配音",
  "drama.myGallery.category.all": "全部",
  "drama.myGallery.category.image": "图片",
  "drama.myGallery.category.video": "视频",
  "drama.myGallery.category.other": "其它",
  "drama.myGallery.status.all": "全部状态",
  "drama.myGallery.status.processing": "处理中",
  "drama.myGallery.status.completed": "已完成",
  "drama.myGallery.status.failed": "失败",
  "drama.myGallery.statusLabel.pending": "待处理",
  "drama.myGallery.statusLabel.processing": "转存中",
  "drama.myGallery.statusLabel.completed": "已完成",
  "drama.myGallery.statusLabel.failed": "失败",
  "drama.myGallery.folderPlaceholder": "目录",
  "drama.myGallery.folderAll": "全部目录",
  "drama.myGallery.searchPlaceholder": "搜名称 / 备注 / 标签",
  "drama.myGallery.totalCount": "共 {count}",
  "drama.myGallery.loadFailed": "加载我的图库失败",
  "drama.myGallery.empty": "还没有转存内容",
  "drama.myGallery.processingTip": "转存中",
  "drama.myGallery.failedDefault": "失败",
  "drama.myGallery.fileTypeFile": "FILE",
  "drama.myGallery.tooltipEdit": "编辑",
  "drama.myGallery.tooltipDownload": "下载",
  "drama.myGallery.tooltipDelete": "删除",
  "drama.myGallery.deleteConfirmTitle": "删除这条转存记录?",
  "drama.myGallery.deleteConfirmDesc": "MinIO 上的对象保留,只清 Mongo 索引",
  "drama.myGallery.deleteOk": "删",
  "drama.myGallery.deleteSuccess": "已删除",
  "drama.myGallery.deleteFailed": "删除失败",
  "drama.myGallery.saveSuccess": "已保存",
  "drama.myGallery.saveFailed": "保存失败",
  "drama.myGallery.editTitle": "编辑:{name}",
  "drama.myGallery.editFolderLabel": "目录",
  "drama.myGallery.editFolderPlaceholder": "选择已有目录或新建",
  "drama.myGallery.editNotesLabel": "备注",
  "drama.myGallery.editTagsLabel": "标签",
  "drama.myGallery.editTagsPlaceholder": "回车添加多个标签",
  "drama.myGallery.videoClose": "关闭",
  "drama.myGallery.videoDownload": "下载",

  // ============ 项目协同 ============
  // workspace.tab.members 已无入口(成员入口在右上角 ProjectMembersMenu Popover);
  // 保留此 key 防其他代码误引用。
  "drama.workspace.tab.members": "成员",
  "drama.members.menu.tooltip": "协同",
  "drama.members.menu.manage": "管理成员", // 兼容 key 保留(已无引用),防误删
  "drama.members.share.addPeople": "添加成员",
  "drama.members.share.emailPlaceholder": "输入邮箱…",
  "drama.members.share.messagePlaceholder": "附言信息(选填)",
  "drama.members.share.send": "邀请",
  "drama.members.share.addMessage": "+ 添加附言",
  "drama.members.share.whoHasAccess": "谁可以访问",
  "drama.members.menu.setEditor": "设为编辑者",
  "drama.members.menu.setViewer": "设为查看者",
  "drama.members.tab.list": "成员",
  "drama.members.tab.pending": "待办邀请",
  "drama.members.empty": '还没有成员,点右上角"邀请"加人',
  "drama.members.invitations.empty": "没有待办邀请",
  "drama.members.you": "我",
  "drama.members.role.owner": "拥有者",
  "drama.members.role.editor": "编辑者",
  "drama.members.role.viewer": "查看者",
  "drama.members.action.invite": "邀请",
  "drama.members.action.transfer": "转让所有权",
  "drama.members.action.remove": "移除",
  "drama.members.action.leave": "退出协同",
  "drama.members.action.revoke": "撤回",
  "drama.members.confirm.remove": "从该项目移除此成员?",
  "drama.members.confirm.leave": "退出该项目协同?",
  "drama.members.confirm.revoke": "撤回这条待办邀请?",
  "drama.members.table.user": "用户",
  "drama.members.table.role": "角色",
  "drama.members.table.joined": "加入时间",
  "drama.members.table.actions": "操作",
  "drama.members.invitations.email": "邮箱",
  "drama.members.invitations.expireAt": "过期时间",
  "drama.members.toast.added": "已加入,通知邮件已发送",
  "drama.members.toast.invited": "邀请邮件已发送",
  "drama.members.toast.lookupFailed": "邮箱未注册或反查失败,已发邀请链接",
  "drama.members.toast.roleUpdated": "角色已更新",
  "drama.members.toast.removed": "已移除",
  "drama.members.toast.revoked": "已撤回",
  "drama.members.toast.transferred": "所有权已转让",
  "drama.members.modal.send": "发送邀请",
  "drama.members.modal.email": "邮箱",
  "drama.members.modal.emailRequired": "请输入邮箱",
  "drama.members.modal.emailInvalid": "邮箱格式不合法",
  "drama.members.modal.role": "角色",
  "drama.members.modal.message": "附言(可选)",
  "drama.members.modal.messagePlaceholder": "简单写一句给对方的话",
  "drama.members.modal.hint":
    "已注册用户会直接加入并收到通知邮件;未注册的会收到邀请链接,注册后接受即可加入。",
  "drama.members.transfer.title": "转让所有权",
  "drama.members.transfer.warning":
    '转让后你将变成"编辑者",需要由新拥有者重新转回。请确认无误。',
  "drama.members.transfer.placeholder": "选择一名编辑者",
  "drama.members.transfer.confirm": "确认转让",

  // 接受邀请页
  "drama.invitation.lede": "{inviter} 邀请你协同项目",
  "drama.invitation.role": "角色:",
  "drama.invitation.invitee": "邀请发往:",
  "drama.invitation.expireAt": "有效期至:",
  "drama.invitation.message": "附言",
  "drama.invitation.acceptingAs": "当前以「{user}」身份接受",
  "drama.invitation.accept": "接受邀请",
  "drama.invitation.later": "稍后再说",
  "drama.invitation.gotoProjects": "回到我的项目",
  "drama.invitation.error.notFound": "邀请不存在或已过期",
  "drama.invitation.error.selfInvite": "你是这条邀请的发起人",
  "drama.invitation.error.generic": "处理邀请失败",

  // ===== 协同模型(viewer 模式 UI 提示)=====
  "drama.collab.tooltipReadOnly":
    "你是查看者,无法执行此操作。如需协作,请联系项目所有者升级为编辑者。",
  "drama.collab.bannerViewer":
    "你正在以「查看者」身份浏览此项目,可读不可编辑;所有写按钮已禁用。",
  "drama.collab.bannerViewerExtra":
    "需要协作?请联系项目所有者把你升级为「编辑者」。",
  "drama.collab.errInsufficientRole": "权限不足:此操作需要编辑者及以上角色",
  "drama.collab.errNoProjectAccess": "你已不再属于此项目,即将返回项目列表",
};
